import { Component, OnInit } from "@angular/core";
import "../../../../assets/js/app_agreement.js";

declare var agreement: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: []
})
export class AppFooterComponent implements OnInit {
  cYear: number = new Date().getFullYear();

  constructor() {
  }

  ngOnInit() {
    agreement.init();
  }
}
